import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";

const DebitWallet = () => {
  // State to hold form data
  const [formData, setFormData] = useState({
    mobileNumber: "",
    name: "",
    email: "",
    amount: "",
    remarks: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submit (Debit action)
  const handleDebit = (e) => {
    e.preventDefault();
    console.log("Debit Wallet", formData);
    // Here, you can send data to a backend or perform some action like processing the debit
  };

  return (
    <Container fluid className="mt-2 px-5">
      <Row>
        <Col md={6} style={{ alignItems: "flex-start", display: "flex" }}>
          <Card
            className="shadow-lg p-4"
            style={{
              borderRadius: "10px",
              backgroundColor: "#f8f9fa",
              minWidth: "300px",
              maxWidth: "400px",
              width: "100%",
            }}
          >
            <Card.Body>
              <h4
                className="mb-4"
                style={{
                  fontWeight: "600",
                  color: "#333",
                  textAlign: "left",
                }}
              >
                Debit Wallet
              </h4>
              <Form onSubmit={handleDebit}>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formMobileNumber">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Mobile Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter mobile number"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleInputChange}
                        required
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formName">
                      <Form.Label style={{ fontWeight: "500" }}>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formEmail">
                      <Form.Label style={{ fontWeight: "500" }}>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formAmount">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Amount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter amount"
                        name="amount"
                        value={formData.amount}
                        onChange={handleInputChange}
                        required
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formRemarks">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Remarks
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        placeholder="Enter remarks"
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleInputChange}
                        rows={3}
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          fontSize: "14px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Button
                      variant="danger"
                      type="submit"
                      className="py-1"
                      style={{
                        backgroundColor: "#dc3545",
                        borderColor: "#dc3545",
                        fontSize: "14px",
                        fontWeight: "500",
                        width: "150px", // Adjusted width
                        height: "40px", // Adjusted height for better proportion
                      }}
                    >
                      Debit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DebitWallet;
